"use strict";
/*
 * Created on 25. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ApprovalStatus_1 = require("../model/ApprovalStatus");

var ApprovalStatusConverter_1 = require("./ApprovalStatusConverter");

var RoleApprovalStatusConverter_1 = require("./RoleApprovalStatusConverter");
/**
 * Default implementation of {@link ApprovalStatusConverter}
 *
 * @author Radek Beran
 */


var ApprovalStatusConverterImpl =
/*#__PURE__*/
function (_ApprovalStatusConver) {
  _inherits(ApprovalStatusConverterImpl, _ApprovalStatusConver);

  function ApprovalStatusConverterImpl(roleApprovalStatusConverter) {
    var _this;

    _classCallCheck(this, ApprovalStatusConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ApprovalStatusConverterImpl).call(this));
    _this.roleApprovalStatusConverter = roleApprovalStatusConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ApprovalStatusConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new ApprovalStatus_1.ApprovalStatus(conversions.asObjectList(source, 'roleStatuses', function (statusDoc) {
        return _this2.roleApprovalStatusConverter.toObject(statusDoc, conversions);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      var document = {};
      Object.assign(document, {
        roleStatuses: source.roleStatuses.map(function (s) {
          return _this3.roleApprovalStatusConverter.toDocument(s, conversions);
        }).toArray()
      });
      return document;
    }
  }]);

  return ApprovalStatusConverterImpl;
}(ApprovalStatusConverter_1.ApprovalStatusConverter);

ApprovalStatusConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [RoleApprovalStatusConverter_1.RoleApprovalStatusConverter])], ApprovalStatusConverterImpl);
exports.ApprovalStatusConverterImpl = ApprovalStatusConverterImpl;